import { render } from "./NotificationLayout.vue?vue&type=template&id=7042f790"
import script from "./NotificationLayout.vue?vue&type=script&lang=js"
export * from "./NotificationLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__